// components/PublicNavbar.jsx

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./styles/Navbar.css";
import useBodyScrollLock from "./hooks/useBodyScrollLock";

export default function NavigationTalent() {
  const [mobileOpen, setMobileOpen] = useState(false);

  // Lock background scroll while the mobile menu is open (iOS-Safari-safe)
  useBodyScrollLock(mobileOpen);

  useEffect(() => {
    const handleScroll = () => {
      const nav = document.getElementById("mainNav");
      nav?.classList.toggle("scrolled", window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <nav className="navi" id="mainNav">
        <Link to="/talentintro" className="nav-logo">
          <img
            src="https://cdn.shopify.com/s/files/1/0712/5755/5236/files/logo.02a8dd85ba2d3d75511a.png"
            alt="DirectSubmit"
          />
        </Link>

        <div className="nav-links">
          <a href="/casting-calls">Casting Calls</a>

          <Link to="/director-tour">Post Casting Notice</Link>
        </div>

        <div className="nav-ctas">
          <Link to="/login" className="btn-ghost">
            Log In
          </Link>

          <Link to="/signup" className="btn-primary">
            Join Now
          </Link>
        </div>

        <button
          className={`nav-hamburger ${mobileOpen ? "open" : ""}`}
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>

      <div className={`mobile-nav ${mobileOpen ? "open" : ""}`}>
        <div className="public-mobile-content">
          <div className="public-mobile-header">
            <button
              className="mobile-menu-close public-mobile-close"
              onClick={() => setMobileOpen(false)}
              aria-label="Close menu"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>

          <div className="public-mobile-links">
            <a href="/casting-calls" onClick={() => setMobileOpen(false)}>
              Casting Calls
            </a>

            <Link to="/director-tour" onClick={() => setMobileOpen(false)}>
              Post Casting Notice
            </Link>
             <Link
                to="/login"
                onClick={() => setMobileOpen(false)}
              >
                Log In
              </Link>

              <Link
                to="/signup"
                onClick={() => setMobileOpen(false)}
              >
                Join Now
              </Link>
          </div>

        {/*   <div className="public-mobile-bottom">
            <div className="public-mobile-nav-ctas">
             
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
}
